import React, { useContext } from "react";
import { LangContext } from "../../contexts/Contexts";

const Download = () => {
  const { lang } = useContext(LangContext);
  const currentLang = (lang || localStorage.getItem("language") || "en")
    .replace(/"/g, "")
    .toLowerCase();
  const isSpanish = currentLang.startsWith("es");
  const googlePlayImage = isSpanish
    ? "./img/logos/google-play_sp.svg"
    : "./img/logos/google-play.svg";
  const appStoreImage = isSpanish
    ? "./img/logos/apple_sp.svg"
    : "./img/logos/apple.svg";

  return (
    <div
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      marginTop: "7%",
    }}
  >
    <img
      src={googlePlayImage}
      alt="Google Play"
      style={{ display: "block", width: "80px" }}
      onClick={() =>
        window.open(
          "https://play.google.com/store/apps/details?id=com.buzzword.viva_nomada",
          "_blank"
        )
      }
    />
    <img
      src={appStoreImage}
      alt="App Store"
      style={{ display: "block", width: "81px" }}
      onClick={() =>
        window.open(
          "https://apps.apple.com/mx/app/viva-nomada/id6739359245",
          "_blank"
        )
      }
    />
  </div>
  
  )
}

export default Download
